import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {SaveGamesWidgetHeaderBox} from "./boxes/save-games-widget-header.box";
import {SwiperGamesListConfiguration} from "../../../services/configurations/config-data-sections/arenas.configuration";

export class SaveGamesWidgetHeaderComponent extends OrbitComponent<{}> {

    private _onClick() {
        const savedGamesSwiperConfig: SwiperGamesListConfiguration = {
            gamesId: this.services.games.savedGames.map(gi => gi.gameType),
            display: true,
            title: this.services.translation.translate("My saved games"),
            useSquareIcons: true
        };

        this.services.verticalGamesList.renderList(savedGamesSwiperConfig);
        this.services.userMenu.closeMenu();
    }

    render() {

        const RightArrowIcon = this.services.theme.currentTheme.icons.rightArrowIcon;
        const SavedGamesIcon = this.services.theme.currentTheme.icons.saveGameIcon;

        return (
            <SaveGamesWidgetHeaderBox className={"cy-save-games-widget-header"}>
                <span>
                    <SavedGamesIcon size={2}/>
                </span>
                <span>
                    {this.services.translation.translate("My saved games")}
                </span>
                <span onClick={this._onClick.bind(this)}>
                    {this.services.translation.translate("ALL")}
                    <RightArrowIcon size={1.5}/>
                </span>
            </SaveGamesWidgetHeaderBox>
        );
    }
}
